import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { Observable, distinctUntilChanged } from 'rxjs';

import { finShare, safeMap } from '@fcom/rx';

import { BaseState, PseudoLocalState } from '../interfaces/app-state.interface';

const pseudoLocalStateSelector = createFeatureSelector<PseudoLocalState>('pseudoLocal');

export const pseudoLocalValueSelector = (key: string): MemoizedSelector<BaseState, string | boolean | undefined> =>
  createSelector(pseudoLocalStateSelector, (s) => s?.[key] as string | boolean | undefined);

/**
 * Selects the current value from the state via given key.
 */
export const pseudoLocal =
  (key: string) =>
  (state$: Observable<BaseState>): Observable<string | boolean> =>
    state$.pipe(
      safeMap((s: BaseState) => s.pseudoLocal),
      safeMap((s: PseudoLocalState) => s[key] as string | boolean),
      distinctUntilChanged(),
      finShare()
    );
